module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.91b3730e.woff";